module.exports = __webpack_public_path__ + "resources/bef059bef4ae3590ac55c1900b94912c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/villain.png
// module id = 229
// module chunks = 0